import { useCallback, useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function useAppUpdate() {
  const updateIntervalRef = useRef<number | null>(null);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      if (registration) {
        if (updateIntervalRef.current !== null) {
          window.clearInterval(updateIntervalRef.current);
        }

        // Poll for updates every 60 seconds while the tab is open
        updateIntervalRef.current = window.setInterval(() => {
          registration.update().catch((error) => {
            console.warn('Service worker update check failed:', error);
          });
        }, 60 * 1000);
      }
    },
  });

  useEffect(() => {
    return () => {
      if (updateIntervalRef.current !== null) {
        window.clearInterval(updateIntervalRef.current);
      }
    };
  }, []);

  const applyUpdate = useCallback(() => {
    updateServiceWorker(true);
  }, [updateServiceWorker]);

  const dismiss = useCallback(() => {
    setNeedRefresh(false);
  }, [setNeedRefresh]);

  return { needRefresh, applyUpdate, dismiss };
}
